<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" sm="8" lg="8">
          <div class="clearfix">
            <div class="float-left display-3">
              <img class="mb-4 mr-3" width="120px"
                   :src="Core.Session.Setting.getSetting('environment.ui.login.logo', Core.Session.Setting.getSetting('environment.ui.logoFull'))">
            </div>
            <h3 class="pt-3">{{Core.Definition.getDefinition('Opération de maintenance')}}</h3>
            <small class="text-muted">
              {{Core.Definition.getDefinition('Définition: Opération de résolution de problème que personne ne comprends effectuée par des magiciens.')}}
            </small><br/><br/>
            <strong>{{Core.Definition.getDefinition('Nous serons de retour très bientôt!')}}</strong>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  data: function () {
    return {
      Core: window.Core
    }
  }
}
</script>
